import { RootPage } from '../page';
import $api from '../../api';
import AddNewProject from './addNewProject';
import { ProjectModel } from '../../models/Gen/BaseModels';
import { sendMessageToExtensionAsync } from '../../utils/extension';

class CrossroadView extends RootPage {
    constructor() {
        super();

        this.projects = ko.observableArray();
        this.isLoaded = ko.observable(false);
        this.hasAccessToAllProjects = ko.observable(window.auth.user.CurrentCompany.HasAccessToAllProjects)
    }

    onInit() {
        this.loadProjects();

        try {
            if (document.referrer && document.referrer.indexOf('account/signup') !== -1 && document.referrer.indexOf('account/signup?inv=') === -1) {
                dataLayer.push({
                    'event': 'form_submit',
                    'enhanced_conversion_data': {
                        "email": window.auth.user.Email
                    }
                });
            }
        } catch (e) {
            console.log('gtm problem')
        }
    }

    loadProjects() {
        $api.projects.getAll({}, {}, (resp) => {
            this.projects.removeAll();

            for (const proj of resp) {
                this.projects.push(new ProjectModel(proj));
            }

            this.isLoaded(true);

            sendMessageToExtensionAsync({
                type: 'sync_workspaces',
                list: resp.map(p => { return { uniqueCode: p.uniqueCode, name: p.name, baseUrl: p.baseUrl, supportedLanguages: p.supportedLanguages } })
            });
        });
    }

    delete(proj) {
        this.confirmStandardDialogAsync('Do you really want to delete this workspace? You won\'t be able to recover it.', 'Enter <b>delete</b>:', 'delete')
            .then(() => {
                $api.projects.remove(
                    { projectCode: ko.unwrap(proj.uniqueCode) },
                    {},
                    () => {
                        window.location.href = '/';
                    }
                );
            })
            .catch(() => {

            });
    }

    goToProject(uniqueCode) {
        window.location.href = '/' + ko.unwrap(uniqueCode) + '/' + 'dashboard/overview';
    }

    showAddNewProjectDialog(showIntroDashboard) {
        if (window.auth.isInTrialAndExpired) {
            this.showDialog('trial-expired-dialog');
        } else {
            TRACK_EVENT('Projects', 'Creating page opened');

            this.showDialog(AddNewProject(this), { showIntroDashboard }, { backdrop: false, bodyFaded: true });
        }
    }
}

export default CrossroadView;
